import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDumbbell, faLightbulb, faStar, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Modal } from './Modal';
import './HelpModal.css';

export const TrainingFacilitiesHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2><FontAwesomeIcon icon={faDumbbell} style={{ marginRight: '8px', color: 'var(--positive-color)' }} />Training Facilities</h2>
        <p style={{ fontSize: '1.1em', marginBottom: '24px' }}>Upgrading your training facilities improves skill development and player performance.</p>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faStar} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Facility Levels & Benefits</h3>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 1: Basic Pitch</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Weekly Cost: £5,000</div>
                    <div style={{ marginTop: '4px' }}>Basic training environment. Minimal player development.</div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 2: Standard Complex</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £750,000 | Weekly Cost: £25,000</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Improved coaching staff
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 3: Advanced Centre</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £3,000,000 | Weekly Cost: £80,000</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Specialized training programs
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Better skill progression
                    </div>
                    <div style={{ color: 'var(--accent-team-color)', marginTop: '4px' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Individual player attribute targeting available
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 4: Elite Facility</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £10,000,000 | Weekly Cost: £200,000</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />World-class coaching
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Significant skill development
                    </div>
                    <div style={{ color: 'var(--accent-team-color)', marginTop: '4px' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Precision attribute targeting for squad optimization
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px', marginBottom: '12px' }}>
                <strong>Level 5: State-of-the-Art Campus</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Upgrade Cost: £25,000,000 | Weekly Cost: £500,000</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Professional training methods
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Exceptional player growth
                    </div>
                    <div style={{ color: 'var(--accent-team-color)', marginTop: '4px' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Advanced individual attribute development system
                    </div>
                </div>
            </div>

            <div style={{ marginTop: '12px', padding: '12px', backgroundColor: 'var(--primary-color)', borderRadius: '4px' }}>
                <strong>Level 6: World Class Performance Hub</strong>
                <div style={{ fontSize: '0.9em', marginTop: '4px' }}>
                    <div>Weekly Cost: £1,000,000</div>
                    <div style={{ marginTop: '4px', color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Unmatched player development
                    </div>
                    <div style={{ color: 'var(--positive-color)' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Maximum skill progression
                    </div>
                    <div style={{ color: 'var(--accent-team-color)', marginTop: '4px' }}>
                        <FontAwesomeIcon icon={faCheck} style={{ marginRight: '4px' }} />Elite player customization with individual targeting
                    </div>
                </div>
            </div>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Training Focus System</h3>
            <p style={{ marginBottom: '12px' }}>You can customize player training using a three-tier priority system:</p>
            <div style={{ backgroundColor: 'rgba(0, 255, 155, 0.1)', padding: '12px', borderRadius: '4px', marginBottom: '12px' }}>
                <ul style={{ margin: '0', paddingLeft: '20px', lineHeight: '1.8' }}>
                    <li><strong>Team Focus:</strong> Default training for entire squad (e.g., "Attacking")</li>
                    <li><strong>Positional Focus:</strong> Override by position (e.g., set Goalkeepers to "Goalkeeping")</li>
                    <li><strong>Individual Focus:</strong> Target specific attributes for individual players (overrides both above)</li>
                </ul>
            </div>
            <p style={{ marginBottom: '12px', fontSize: '0.95em' }}>Go to the <strong>Training Facilities → Focus</strong> tab and select the <strong>Individual Focus</strong> section to assign specific training plans (General, Fitness, Rest, Goalkeeping, Defending, Midfield, or Attacking) to each player.</p>
        </div>

        <div className="help-section">
            <h3><FontAwesomeIcon icon={faLightbulb} style={{ marginRight: '8px', color: 'var(--warning-color)' }} />Cost-Benefit Strategy</h3>
            <div style={{ backgroundColor: 'rgba(0, 255, 155, 0.1)', padding: '12px', borderRadius: '4px' }}>
                <ul style={{ margin: '0', paddingLeft: '20px', lineHeight: '1.8' }}>
                    <li><strong>Early Game:</strong> Focus on recruiting talent. Upgrade facilities when you have stable finances.</li>
                    <li><strong>Mid Game:</strong> Upgrade to Level 3-4 to accelerate player development. Use individual targeting to fine-tune player development.</li>
                    <li><strong>Budget Crunch:</strong> Downgrading saves significant weekly wages while only moderately reducing development speed.</li>
                    <li><strong>Top Tier:</strong> Levels 5-6 are for rich clubs chasing titles. Individual targeting becomes crucial for creating your ideal squad.</li>
                </ul>
            </div>
        </div>

        <div className="modal-actions">
            <button className="button primary" onClick={onClose}>Got it!</button>
        </div>
    </Modal>
);
